"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grants = void 0;
var Grants;
(function (Grants) {
    Grants["SlackChannelsRead"] = "slack/channels_read";
    Grants["MsTeamsChannelsRead"] = "ms_teams/channels_read";
    Grants["ChannelDataRead"] = "channel_data/read";
    Grants["ChannelDataWrite"] = "channel_data/write";
    Grants["UserFeedRead"] = "user/feed_read";
})(Grants || (exports.Grants = Grants = {}));
